import _ from 'lodash';

const fromUsersResult = (result, query) => {
  const columns = _.isNil(query.columns) ? query.groupBy : query.columns;
  return {
    info: {
      type: 'eventsResult',
      query,
      eventName: query.eventName,
    },
    result: {
      columns,
      rows: result.rows,
    },
  };
};

export default fromUsersResult;
